export default __webpack_public_path__ + "static/media/logo-determined-on-light-vertical.7dc4618c.svg";